import { API_GET_GOOGLE_PROFILE_BEFORE_SNAPSHOT } from '../../../../utils';

export const getGoogleProfileBeforeSnapshot = async (clientId) => {
  if (!API_GET_GOOGLE_PROFILE_BEFORE_SNAPSHOT || !clientId) {
    return null;
  }

  try {
    const query = new URLSearchParams({ clientId }).toString();
    const separator = API_GET_GOOGLE_PROFILE_BEFORE_SNAPSHOT.includes('?')
      ? '&'
      : '?';
    const requestUrl = `${API_GET_GOOGLE_PROFILE_BEFORE_SNAPSHOT}${separator}${query}`;

    const response = await fetch(requestUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      return null;
    }

    const payload = await response.json();

    // Accept both formats and return normalized before/after payload:
    // 1) { beforeSnapshot: { criteria, percentage }, afterComputed: { criteria, percentage } }
    // 2) Legacy: { criteria, percentage }
    if (
      payload?.beforeSnapshot?.criteria &&
      typeof payload.beforeSnapshot.criteria === 'object'
    ) {
      return {
        beforeCriteria: payload.beforeSnapshot.criteria,
        beforePercentage: payload.beforeSnapshot.percentage || null,
        afterCriteria:
          payload?.afterComputed?.criteria &&
          typeof payload.afterComputed.criteria === 'object'
            ? payload.afterComputed.criteria
            : null,
        afterPercentage: payload?.afterComputed?.percentage || null
      };
    }

    if (payload?.criteria && typeof payload.criteria === 'object') {
      return {
        beforeCriteria: payload.criteria,
        beforePercentage: payload.percentage || null,
        afterCriteria: null,
        afterPercentage: null
      };
    }

    return null;
  } catch (error) {
    console.error('Error fetching immutable before snapshot', error);
    return null;
  }
};
